import { getAppSettingsValue } from '../../app/selectors/app-settings-selectors';
import {
  getListNumberOfRows,
  getListLayoutId,
  getListNumberOfPosts,
  getListMasonryNumberOfPosts,
} from './app-settings-selectors';
import { getLayoutName as getLayoutNameById } from '../constants/layouts';
import {
  getLayoutConfig as getLayoutConfigByName,
  FONT_COLOR_KEYS_STANDARD,
  FONT_COLOR_KEYS_TEXT_ON_IMAGE,
  isLayoutNameTextOnImage,
} from '../services/layout-config';
import {
  LIST_MASONRY_NUMBER_OF_POSTS,
  LIST_NUMBER_OF_POSTS,
  LIST_NUMBER_OF_ROWS,
  LIST_POST_LIMIT_TYPE_PATH,
  LIST_POST_LIMIT_TYPE_LIMITED,
} from '../constants/wix-params';

export const getLayoutName = ({ state, isMobile }) => {
  const layoutName = getLayoutNameById(getListLayoutId(state));
  return isMobile ? getLayoutConfigByName(layoutName).mobileLayout : layoutName;
};

export const getLayoutConfig = ({ state, isMobile }) => getLayoutConfigByName(getLayoutName({ state, isMobile }));

export const getIsLayoutTextOnImage = ({ state, isMobile }) =>
  isLayoutNameTextOnImage(getLayoutName({ state, isMobile }));

export const getFontAndColorKeys = (state) =>
  getIsLayoutTextOnImage({ state }) ? FONT_COLOR_KEYS_TEXT_ON_IMAGE : FONT_COLOR_KEYS_STANDARD;

export const getListPostLimitType = (state) => {
  const postLimitType = getAppSettingsValue({ state, key: LIST_POST_LIMIT_TYPE_PATH, fallback: -1 });
  if (postLimitType !== -1) {
    return postLimitType;
  }

  return LIST_POST_LIMIT_TYPE_LIMITED;
};

export const hasPostLimit = (state) => getListPostLimitType(state) === LIST_POST_LIMIT_TYPE_LIMITED;

const INFINITE_SCROLL_PAGE_SIZE = 10;

export const getPostsPerPage = (state) => {
  const layoutConfig = getLayoutConfig({ state });
  const settingsKey = layoutConfig.postsNumberSettingsKey;
  const pageSize = hasPostLimit(state) ? undefined : INFINITE_SCROLL_PAGE_SIZE;

  switch (settingsKey) {
    case LIST_MASONRY_NUMBER_OF_POSTS:
      return pageSize || getListMasonryNumberOfPosts(state);
    case LIST_NUMBER_OF_POSTS:
      return pageSize || getListNumberOfPosts(state);
    case LIST_NUMBER_OF_ROWS:
      return layoutConfig.postsPerRow * (pageSize || getListNumberOfRows(state));
    default:
      throw new Error(`Invalid posts number settings key ${settingsKey}`);
  }
};
